const BaseUrl = process.env.REACT_APP_WS_URL

export const getWsUrl = (url: string) => `${BaseUrl}${url}`
